import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button, ButtonWithSpinner, Card, CardTitle, Divider } from '@reveni-io/reveni-ui'

import NewShipmentSettings from '@/parcels/components/NewShipmentSettings/NewShipmentSettings'
import routes from '@/Router/routes.constants'

import CurrentShipment from './CurrentShipment/CurrentShipment'
import NewShipment from './NewShipment/NewShipment'
import * as Styles from './styles'

const SummaryCard = ({
  lineItems = [],
  selectedItemsIds = [],
  carrierServices,
  carrierServiceForNewShipment,
  setCarrierServiceForNewShipment,
  locationForNewShipment,
  setLocationForNewShipment,
  locations,
  parcelId,
  onSplitParcel,
  splittingParcel,
  isSplitParcelEnable,
  senderLocation,
}) => {
  const { t } = useTranslation()
  const navigation = useNavigate()

  const onCancel = () => {
    navigation(routes.parcelDetailPage.replace(':id', parcelId))
  }

  const itemsWithIndex = lineItems.map((item, index) => ({ ...item, originalIndex: index + 1 }))
  const selectedItems = itemsWithIndex.filter(item => selectedItemsIds.includes(item.id))
  const remainingItems = itemsWithIndex.filter(item => !selectedItemsIds.includes(item.id))

  return (
    <Card showBorder={false}>
      <CardTitle>{t('Resumen')}</CardTitle>
      <Styles.MainContainer>
        <CurrentShipment lineItems={remainingItems} />
        <Divider />
        <NewShipment lineItems={selectedItems} />
        <Divider />
        <NewShipmentSettings
          carrierServices={carrierServices}
          carrierServiceForNewShipment={carrierServiceForNewShipment}
          setCarrierServiceForNewShipment={setCarrierServiceForNewShipment}
          locationForNewShipment={locationForNewShipment}
          setLocationForNewShipment={setLocationForNewShipment}
          locations={locations}
          senderLocation={senderLocation}
          withTitle
        />
        <Styles.ActionsContainer>
          <ButtonWithSpinner
            disabled={!isSplitParcelEnable || splittingParcel}
            fullWidth
            defaultLabel={t('Continuar')}
            loadingLabel={t('Dividiendo envío...')}
            onClick={onSplitParcel}
          />
          <Button fullWidth variant="outlined" onClick={onCancel}>
            {t('Cancelar')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Card>
  )
}

export default SummaryCard
